import { render } from "./Fila.vue?vue&type=template&id=7ae08cab&scoped=true"
import script from "./Fila.vue?vue&type=script&lang=js"
export * from "./Fila.vue?vue&type=script&lang=js"

import "./Fila.vue?vue&type=style&index=0&id=7ae08cab&lang=scss&scoped=true"

import exportComponent from "/Users/anfloman/Desktop/ComponentesAlgoritmica/TemaWordpress/tema/vuejs/ParrillaPrecios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ae08cab"]])

export default __exports__